/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
// Component: p4Oo-xLzW7co
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PageLayout from "../../PageLayout"; // plasmic-import: EwKexkGqvtH7/component
import SectionHero from "../../SectionHero"; // plasmic-import: Ol7Sy0qUOFXf/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: p4Oo-xLzW7co/css

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "o21p | nexus",
    openGraph: {
      title: "o21p | nexus"
    },
    twitter: {
      card: "summary",
      title: "o21p | nexus"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicHomepage__VariantProps = new Array();

export const PlasmicHomepage__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "all",
          "root_reset_ec33x5SEN4aEEFQbKCmZsX",
          "plasmic_default_styles",
          "plasmic_mixins",
          styleTokensClassNames,
          sty.root
        )}
      >
        <PageLayout
          data-plasmic-name={"pageLayout"}
          data-plasmic-override={overrides.pageLayout}
          className={classNames("__wab_instance", sty.pageLayout)}
          content={
            <React.Fragment>
              <SectionHero
                data-plasmic-name={"sectionHero"}
                data-plasmic-override={overrides.sectionHero}
                className={classNames("__wab_instance", sty.sectionHero)}
                colWidth={"medium"}
                navbar={
                  <div
                    data-plasmic-name={"nav"}
                    data-plasmic-override={overrides.nav}
                    className={classNames("all", sty.nav)}
                  >
                    <div className={classNames("all", sty.freeBox___9Zj04)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__sgn2H
                        )}
                      >
                        {"["}
                      </div>
                      <div className={classNames("all", sty.freeBox__nu6Hg)}>
                        <h1
                          className={classNames(
                            "all",
                            "h1",
                            "h1__ec33x",
                            "__wab_text",
                            sty.h1__dnyRq
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__ec33x",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__q9Rq
                                )}
                                href={"https://o21p.com/"}
                                platform={"react"}
                              >
                                {"o21p"}
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                          </React.Fragment>
                        </h1>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__idBpE
                          )}
                        >
                          {"|"}
                        </div>
                        <h1
                          className={classNames(
                            "all",
                            "h1",
                            "h1__ec33x",
                            "__wab_text",
                            sty.h1__zXgie
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__ec33x",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__u8Res
                                )}
                                href={"https://nexus.o21p.com/"}
                                platform={"react"}
                              >
                                {"nexus"}
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                          </React.Fragment>
                        </h1>
                      </div>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__e7Lr
                        )}
                      >
                        {"]"}
                      </div>
                    </div>
                  </div>
                }
                sectionId={"top"}
                slot={
                  <div className={classNames("all", sty.freeBox__ipBxg)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__e13Wc
                      )}
                    >
                      {
                        "A space for independent experts and agencies to present who they are, showcase what they do, and become part of the o21p network."
                      }
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__eaPsD
                      )}
                    >
                      {"-- coming soon --\n\n\n\n\n\n\n\n\n\n\n"}
                    </div>
                  </div>
                }
              >
                <div
                  className={classNames("all", "__wab_text", sty.text___5YMxf)}
                >
                  {"nexus"}
                </div>
              </SectionHero>
              <section
                data-plasmic-name={"section999"}
                data-plasmic-override={overrides.section999}
                className={classNames("all", sty.section999)}
              >
                <div className={classNames("all", sty.freeBox___1UnW)}>
                  <div
                    className={classNames("all", "__wab_text", sty.text__lEy9C)}
                  >
                    {
                      "\u00a92026 o21p -- all rights reserved. Contact: team@o21p.com"
                    }
                  </div>
                </div>
              </section>
            </React.Fragment>
          }
          layoutSections={"withNav"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "pageLayout", "sectionHero", "nav", "section999"],
  pageLayout: ["pageLayout", "sectionHero", "nav", "section999"],
  sectionHero: ["sectionHero", "nav"],
  nav: ["nav"],
  section999: ["section999"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    pageLayout: makeNodeComponent("pageLayout"),
    sectionHero: makeNodeComponent("sectionHero"),
    nav: makeNodeComponent("nav"),
    section999: makeNodeComponent("section999"),
    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/",
      pagePath: "/",
      params: {},
      query: {}
    })
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
